'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconThreeVerticalLines, iconThreeVerticalLinesTag } from '@ni/nimble-components/dist/esm/icons/three-vertical-lines';
import { wrap } from '../../utilities/react-wrapper';

export type { IconThreeVerticalLines };
export { iconThreeVerticalLinesTag };
export const NimbleIconThreeVerticalLines = wrap(IconThreeVerticalLines);